import React, {Component} from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux';

import KeywordListHeader from '../../components/contents/keyword/KeywordListHeader'
import KeywordList from '../../components/contents/keyword/KeywordList'
import Pagination from '../../components/common/Pagination';
import { parseListParams } from '../../components/common/EntryListHelper';
import ListWriteTitle from "../../components/common/list/ListWriteTitle";

@connect(state => ({
    items: state.keyword.item.items,
    totalCount: state.keyword.item.totalCount,
    searchKeyword: state.keyword.condition.searchKeyword,
}))
class KeywordApp extends Component {

    render() {
        const { totalCount, searchKeyword } = this.props;

        return (
				<div className="inner_article contents_article">
					<h2 id="kakaoBody" className="screen_out">티스토리 관리센터 본문</h2>
					<ListWriteTitle type="keyword" headLabel="키워드" totalCount={totalCount} searchKeyword={searchKeyword}/>
					<Route path="/keywords" exact={false} strict={false} component={KeywordListHeader}/>
					<Route path="/keywords" exact={false} strict={false} component={KeywordList}/>
					<Pagination totalCount={totalCount} parseListParams={parseListParams}/>
				</div>
        )
    }
}

export default KeywordApp;
